import { colors, FlexContainer as FlexContainer_, system } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { FRONT_PLANS } from 'Constants/plans';
import { DESKTOP_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';

export const ColorByPlan = {
  [FRONT_PLANS.PRO]: colors.pro_200,
  [FRONT_PLANS.FULL]: colors.full_200,
  [FRONT_PLANS.FLEX]: colors.live_200,
  [FRONT_PLANS.BASIC]: system.plans.fds_sys_color_plan_basic_secondary,
};

export const Container = styled(FlexContainer_)<{ $planName: string }>`
  position: relative;
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    padding: ${({ theme: { reference } }) => reference.dimension_16};
  }
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    flex-direction: column;
  }
  background: ${({ $planName }) => ColorByPlan[$planName]};
`;

export const SpinnerFlexContainer = styled(FlexContainer_)`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 0.7;
    }
  }
  background-color: ${system.background.fds_sys_color_skeleton};
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  animation: fadeIn 0.5s forwards;
`;
